import { Injector, Injectable } from "@angular/core";
import { cgpAuthentication } from "../../../modules/cgp-authentication";
import { BaseHttpService } from "../../shared/services/base-http.service";
import { HttpParams } from "@angular/common/http";
import { getEnv } from "src/modules/utility";
import { mescServicesUrl } from "./config";

export abstract class MescService extends BaseHttpService {
    private readonly tableName: string;
    BASE_URL: string;
    constructor(
        injector: Injector,
        tableName: string,
    ) {
        super(injector);
        this.tableName = tableName;
        this.BASE_URL = mescServicesUrl[getEnv()];
    }

    /**
     * 
     */
    read = (path = '', catchError = true): Promise<any> => super.fetch(this.BASE_URL + this.tableName + path, catchError);
    /**
     * 
     */
    search = (body: any, path = '', catchError = true, searchParams: HttpParams = null): Promise<any> => {
        return super.post(body, this.BASE_URL + this.tableName + path, catchError, searchParams);
    }
    /**
     * 
     */
    save = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => {
        return isNew ? super.post(obj, this.BASE_URL + this.tableName + path, catchError) : super.put(obj, this.BASE_URL + this.tableName + path, catchError);
    }
    /**
     * 
     */
    remove = (path: string, catchError = true): Promise<any> => super.delete(this.BASE_URL + this.tableName + path, catchError);
    /**
     * 
     */
    export = (body: any, path = '', searchParams: HttpParams = null): Promise<any> => super.download(body, this.BASE_URL + this.tableName + path, searchParams);
    /**
     * 
     */
    getCGPUser = (gmin: string, catchError = true): Promise<any> => super.fetch(this.BASE_URL + `common/user/CgpUserByGminGmid?gminGmid=${gmin}`, catchError);
    /**
     * 
     */
    getCurrentUserGmin = (): string => cgpAuthentication.getUserInfo().gmin || cgpAuthentication.getUserInfo().gmuniqueidentifier;
}


@Injectable()
export class BaseService extends MescService {
    constructor(injector: Injector) { super(injector, ""); }
}

@Injectable()
export class ModuleService extends MescService {
    constructor(injector: Injector) { super(injector, "common/Module"); }
}

@Injectable()
export class UserService extends MescService {
    constructor(injector: Injector) { super(injector, "common/User"); }
}

@Injectable()
export class UserProfileService extends MescService {
    constructor(injector: Injector) { super(injector, "common/User/UserProfile"); }
}

@Injectable()
export class RoleService extends MescService {
    constructor(injector: Injector) { super(injector, "common/Role"); }
}

@Injectable()
export class UserLastLoginDateService extends MescService {
    constructor(injector: Injector) { super(injector, "User/LastLoginDate"); }
}
